'use strict'

export default function decapitalize(string) {
  return string.charAt(0).toLowerCase() + string.substr(1)
}
